const formatOptions = {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2
};
export const formatStringAccountBalance = (value) => {
    try {
        if (!value)
            return ' - ';
        const numberValue = parseFloat(value);
        const formattedValue = numberValue.toLocaleString('en-US', formatOptions);
        return formattedValue;
    }
    catch (error) {
        console.log(error);
        return value;
    }
};
export const formatAccountBalance = (value) => {
    try {
        if (isNaN(value))
            return ' - ';
        const numberValue = parseFloat(value.toString());
        const formattedValue = numberValue.toLocaleString('en-US', formatOptions);
        return formattedValue;
    }
    catch (error) {
        console.log(error);
        return `${value}`;
    }
};
export const parseVirtualAccountBalance = (value) => {
    try {
        if (!value)
            return 0.0;
        return parseFloat(value);
    }
    catch (error) {
        console.error(error);
        return 0.0;
    }
};
export const sumBalances = (virtualAccounts) => {
    try {
        const sum = virtualAccounts.reduce((acc, curr) => {
            const balance = parseVirtualAccountBalance(curr.balance);
            return acc + balance;
        }, 0);
        return sum;
    }
    catch (error) {
        console.error(error);
        return 0.0;
    }
};
